import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { StudentapiService } from '../studentapi.service';


@Component({
  selector: 'app-stud-new',
  templateUrl: './stud-new.component.html',
  styleUrls: ['./stud-new.component.css']
})
export class StudNewComponent implements OnInit {
  isShowDiv = true;
  isShowtableDiv = true;
  showDiv = {
    previous : false,
    current : false,
     next : false
  }
  studentdata: any;
  selctform !: FormGroup ;
  erno: any;
  stud: any;
  public temp: Object=false;
  dtOptions: DataTables.Settings = {};
  seat: any;
  stname: any;
  stream: any;
  hsscdata: any;
  ssub1: any;
  s1name: any;
  s2name: any;
  s3name: any;
  s4name: any;
  s5name: any;
  s6name: any;
  s7name: any;
  result:any;
  s1thext: any;
  s1thextg: any;
  s1thint: any;
  sb1x: any;
  sb1gr: any;
  s2thext: any;
  s2thextg: any;
  s2thint: any;
  sb2gr: any;
  sb2x: any;
  s3thext: any;
  s3thextg: any;
  s3thint: any;
  sb3gr: any;
  sb3x: any;
  s4thext: any;
  s4thextg: any;
  s4thint: any;
  sb4gr: any;
  sb4x: any;
  s5thext: any;
  s5thextg: any;
  s5thint: any;
  sb5gr: any;
  sb5x: any;
  s6thext: any;
  s6thextg: any;
  s6thint: any;
  sb6gr: any;
  sb6x: any;
  s7thext: any;
  s7thextg: any;
  s7thint: any;

  sb7x: any;
  sb7gr: any;
  ttl: any;
  exam: any;
  sb1th: any;
  sb1p: any;
  sb1pit: any;
  sb1prc: any;
  sb2p: any;
  sb2pit: any;
  sb2prc: any;
  sb3p: any;
  sb3pit: any;
  sb3prc: any;
  sb4p: any;
  sb4pit: any;
  sb4prc: any;
  sb5p: any;
  sb5pit: any;
  sb5prc: any;
  sb6p: any;
  sb6pit: any;
  sb6prc: any;
  sb7p: any;
  sb7pit: any;
  sb7prc: any;

  constructor(public formbuilder:FormBuilder,public router:Router,private api:StudentapiService) { }

  ngOnInit(): void {

    this.selctform = this.formbuilder.group({
      erno:['']
    });

  }

   
  toggleDisplayDiv() {
    
    // this.isShowDiv = !this.isShowDiv;
    this.showDiv.previous = !this.showDiv.previous;
    this.showDiv.current = false;
    this.showDiv.next = false
    
  }

  onStudentdatassc()
{
 
    let stud :{ Roll_No :any} ={
      Roll_No : this.selctform.controls.Roll_No.value
    }

    console.log(stud);
    return this.api.post('/StudentApi/studentdatabyRollno',stud).subscribe((res:any)=>{
      console.log(res);
      this.studentdata =res.Data;
      this.temp = true;
    },
    err=>{
     alert('Error');
    });
}
 
getSSCstudents()
{
   return this.api.get('/StudentApi/studentdataofssc').subscribe((res:any)=>{
     console.log(res);
     this.studentdata =res.Data;
     this.temp = true;
   },
   err=>{
    alert('Error');
   });
}


activeTab = 'ssc';

ssc(activeTab: string){
  this.activeTab = activeTab;
}

hssc(activeTab: string){
  this.activeTab = activeTab;
}


}
